import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "import_active",
  "use": "import_active-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"import_active\"><path fill-rule=\"evenodd\" d=\"M9 8.075V15h1V8.075L11.673 10H13L9.5 6 6 10h1.326L9 8.075Zm7.25.175V9.5A3.755 3.755 0 0 1 20 13.25 3.755 3.755 0 0 1 16.25 17H5c-2.757 0-5-2.242-5-5 0-2.364 1.654-4.339 3.863-4.858C4.387 4.225 6.933 2 10 2a6.257 6.257 0 0 1 6.25 6.25Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol